// extracted by mini-css-extract-plugin
export var alertIcon = "_uh-0";